import React from "react";
import { Row, Col, Grid, FormGroup, Form, FormControl, ControlLabel, Checkbox, MenuItem, DropdownButton, ButtonToolbar } from 'react-bootstrap'
import Features from "../Features/Features";
import Breadcrumbing from "../Breadcrumbing/Breadcrumbing";
import Signwith from "../Signwith/Signwith";


class ForgitPassword extends React.Component {

    render() {
        return (

            <Grid>
                <div className="ForgitPassword">
                <div className="ForgitPassword-caption">
                <h3>Forgot Password </h3>
                <p> Follow The Instructions</p>
                </div>
                
        
        <input type="text" placeholder="Type Your E-Mail Here" id="formHorizontalEmail" class="form-control"/>
        
        <button type="button" class="Forgit__password-btn btn">Request Password</button>
{/* <Signwith/> */}
        
        
        </div>

            </Grid>


        );
    }
}

export default ForgitPassword;



// WEBPACK FOOTER //
// ./src/Components/ForgitPassword/ForgitPassword.jsx